export default __webpack_public_path__ + "static/media/background-login-register.dfc66167.jpg";